import { AssertionsType } from 'entities/Assertions/types';
import { SandboxParams } from 'entities/generative-models/types';

export type UploadSource = 'DIRECT' | 'FTP' | 'GOOGLE';

export enum CategoryTypeEnum {
	custom = 'custom',
	generative_model = 'generative',
}

export type SavedFileStatus = 'IN_PROCESS' | 'UNRECOGNIZED' | 'RECOGNIZED';

export enum EReviewIssue {
	PARTNER_ASSOCIATION_FAILURE = 'PARTNER_ASSOCIATION_FAILURE',
	RECEIVER_ID_NOT_FOUND = 'RECEIVER_ID_NOT_FOUND',
	ITEM_CODE_NOT_FOUND = 'ITEM_CODE_NOT_FOUND',
	CODE_CELL_MULTI_CONFLICT = 'CODE_CELL_MULTI_CONFLICT',
	MISSING_ITEMS_TABLE = 'MISSING_ITEMS_TABLE',
	MISSING_QUANTITY_COLUMN = 'MISSING_QUANTITY_COLUMN',
	INVALID_QUANTITY_VALUE = 'INVALID_QUANTITY_VALUE',
	MISSING_CODICE_COLUMN = 'MISSING_CODICE_COLUMN',
}

export type LabelType = 'table' | 'string';
export type LabelColumnType = 'string' | 'number';

export type BoundingRegionsType = {
	pageNumber: number;
	boxPosition: {
		x: number;
		y: number;
		width: number;
		height: number;
	};
};

export type LabelStructureType = {
	label?: string;
	content: string;
	boundingRegions?: BoundingRegionsType[];
	assertionSetsId?: string;
	assertionsData?: AssertionsType;
	autocomplete?: boolean;
};

export type TableCellCandidateType = {
	Code: string;
	Description: string;
};

export type TableCellType = LabelStructureType & {
	rowIndex: number;
	columnIndex: number;
	status?: 'MULTI';
	itemCandidates?: TableCellCandidateType[];
	manualOverride?: TableCellCandidateType | null;
	replaceVal?: string | null;
};
export type TableLabelsStructureType = {
	columnsHeaders: {
		columnName: string;
		autocomplete?: boolean;
	}[];
	cells: TableCellType[];
	label?: string;
};

export type TableColumnDraft = {
	columnName: string;
	sourceIndex: number | null;
};

export type StringRecognizedLabel = LabelStructureType & { type: 'string' };
export type TableRecognizedLabel = TableLabelsStructureType & { type: 'table' };

export type RecognizedLabelsStructureType = StringRecognizedLabel | TableRecognizedLabel;

export type LabelTableColumnsType = {
	name: string;
	type: LabelColumnType;
	description?: string;
};

export type GenerativeLabelsType = {
	name: string;
	type: LabelType;
	description?: string;
	columns?: LabelTableColumnsType[];
};

export type FileType = {
	_id: string;
	fileName: string;
	size: 0;
	companyId: string;
	uploaderId: {
		_id: string;
		email: string;
		firstName: string;
		lastName: string;
		avatar: string;
	};
	uploadSource: UploadSource;
	category: CategoryTypeEnum;
	status: SavedFileStatus;
	pathIdentifier: string;
	recognitionTemplateId: string;
	hash: string;
	autoRemoveAt: string;
	createdAt: string;
	updatedAt: string;
	assertionSetsId?: string | null;
	partnerId?: string | null;
	receiverId?: string | null;
	recognizedLabels: RecognizedLabelsStructureType[];
	labels: GenerativeLabelsType[];
	autocomplete?: boolean;
	reviewIssues?: EReviewIssue[];
	partnerCandidates?: string[];
	customModelId?: string;
	generativeModelId?: string;
	sandbox?: SandboxParams;
	splitSource?: any;
};

export type AlreadyExportedFilesType = {
	fileId: string;
	fileName: string;
	createdAt: string;
};
